export default {
	id: "",
	bustout_reason: "",
	bustout_date: "",
	cancel_other_reason: "",
}